export default __webpack_public_path__ + "static/outsource@2x-4b60166b901a88ad1d9313f55493cd3e.png";